module.exports = __webpack_public_path__ + "media/images/emblems/Seengen-blason-9f0e47465badc6c083a63c9ad230e765.png";